import { render, staticRenderFns } from "./ReportTitleBar.vue?vue&type=template&id=585a33d9&"
import script from "./ReportTitleBar.vue?vue&type=script&lang=js&"
export * from "./ReportTitleBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports